import classnames from 'classnames'
import PropTypes from 'prop-types'

import headerLogo from '../shared_assets/everplans-transparent-white-logo.svg'

const Logo = ({className}) => (
  <img
    alt='Everplans logo'
    className={classnames('everplans-logo', className)}
    src={headerLogo}
  />
)

Logo.propTypes = {className: PropTypes.string}

export default Logo
